/**
 * Appends the current access token as ?token= so <img src> and download
 * links can reach the authenticated /api/v1/files/* endpoint.
 */
export function fileUrl(path: string | null | undefined): string | undefined {
  if (!path) return undefined
  const token = localStorage.getItem('access_token')
  if (!token) return path
  const sep = path.includes('?') ? '&' : '?'
  return `${path}${sep}token=${encodeURIComponent(token)}`
}
